import "../../../pages/products/productDetails.css";
import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import Footer from "../../footer/footer";
import copper from "../../../../Assets/image/फूटर आयकॉन/WSjZa6G8-800-800.png";
import Quality from "../../../../Assets/image/फूटर आयकॉन/[CITYPNG.COM]HD Quality Golden Logo Label PNG - 1500x1500.png";
import CustomNavbar from "../productnavbar";
import { Tabs, Tab, Spinner, Button } from "@nextui-org/react";
import RevealBlurFX from "../../../../components/Effect/RevealBlurFX";
import { BASEURL } from "../../../../constant/constant";
import ThreeDViewer from "../../../../components/ThreeDViewer/page";
import { FaWhatsapp, FaTag, FaPhoneAlt, FaFilePdf } from "react-icons/fa";

function ProductDetails() {
  const { slug, sub_category_slug, product_item_id } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tabNumber, setTabNumber] = useState(null);
  const hasFetched = useRef(false);
  useEffect(() => {
    if (hasFetched.current) return;
    if (!slug || !sub_category_slug) return;

    fetchProducts(slug, sub_category_slug);

    if (product_item_id) {
      setTabNumber(Number(product_item_id));
    }
    hasFetched.current = true;
  }, [slug, sub_category_slug, product_item_id]);

  const fetchProducts = async (slug, sub_category_slug) => {
    try {
      setLoading(true);

      const response = await fetch(
        `${BASEURL}/api/product/getProducts/${slug}/${sub_category_slug}`,
        {
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        }
      );

      const data = await response.json();

      if (Array.isArray(data.products)) {
        setProducts(data.products);
      } else {
        setProducts([]);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  // build specs table from API fields
  const renderKVRow = (label, value) => {
    if (!value) return null;
    return (
      <tr key={label}>
        <td className="border px-3 py-2 text-gray-700">{label}</td>
        <td className="border px-3 py-2 text-gray-900">{value}</td>
      </tr>
    );
  };

  const renderParameterTable = (product) => {
    const rows = [];

    rows.push(
      renderKVRow("Model number", product.product_id),
      renderKVRow("Voltage rating", product.voltage_rating),
      renderKVRow("Current rating", product.current_rating),
      renderKVRow("Color", product.color),
      renderKVRow("Top highlights", product.top_highlights),
      renderKVRow("Accessories", product.accessories),
      renderKVRow("Weight", product.weight),
      renderKVRow("Dimension", product.dimension),
      renderKVRow("Compatible devices", product.compatibile_devices),
      renderKVRow("Form factor", product.form_factor),
      renderKVRow("Enclosure material", product.enclosure_material),
      renderKVRow("IP rating", product.ip_rating),
      renderKVRow("Control method", product.control_method),
      renderKVRow("Connector type", product.connector_type),
      renderKVRow("Category", product.category),
      renderKVRow("Warranty", product.warranty),
      renderKVRow("product price", product.product_price),
      renderKVRow("Power ratings", product.powerratings),
      renderKVRow("Protection", product.protection),
      renderKVRow("Communication", product.communication),
      renderKVRow("I/O ratings", product.ioratings),
      renderKVRow("Support channel", product.supportchannel)
    );

    const filteredRows = rows.filter(Boolean);
    if (filteredRows.length === 0) return null;

    return (
      <div className="mb-4 w-full">
        <h4 className="font-semibold text-lg mb-2">Product Details</h4>
        <table className="table-auto w-full border border-gray-300 text-sm">
          <thead className="bg-gray-300">
            <tr>
              <th className="border px-3 py-2 text-left">Parameter</th>
              <th className="border px-3 py-2 text-left">Value</th>
            </tr>
          </thead>
          <tbody>{filteredRows}</tbody>
        </table>
      </div>
    );
  };

  // zoom behavior (mouse move)
  useEffect(() => {
    const wrapper = document.querySelector(".product-image-zoom-wrapper");
    if (!wrapper) return;

    const inner = wrapper.querySelector(".product-image-zoom-inner");
    const zoomImg = wrapper.querySelector(".product-image-zoomed");
    const lens = wrapper.querySelector(".product-image-zoom-lens");

    const handleMove = (e) => {
      if (!inner || !zoomImg) return;
      const rect = inner.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const xPercent = (x / rect.width) * 100;
      const yPercent = (y / rect.height) * 100;

      zoomImg.style.transformOrigin = `${xPercent}% ${yPercent}%`;
      zoomImg.style.transform = "scale(2.2)";

      if (lens) {
        const halfW = lens.offsetWidth / 2;
        const halfH = lens.offsetHeight / 2;
        lens.style.left = `${x - halfW}px`;
        lens.style.top = `${y - halfH}px`;
      }
    };

    inner.addEventListener("mousemove", handleMove);

    return () => {
      inner.removeEventListener("mousemove", handleMove);
    };
  }, [products]);

  const handleOpenBrochure = (product) => {
    if (!product.brochure) return;

    const url = `${BASEURL}${product.brochure}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };


  return (
    <>
      {/* <CustomNavbar /> */}
      <div className="productsdetails flex flex-col p-2">
        <div>
          <div className="background-textpd">Product Details</div>
        </div>

        <div className="productsdetails-main">
          {loading ? (
            <div className="flex justify-center items-center h-48">
              <Spinner color="warning" label="Loading Products..." />
            </div>
          ) : products.length === 0 ? (
            <p className="text-center mt-5">No products found.</p>
          ) : (
            <Tabs
              {...(tabNumber != null && { selectedKey: tabNumber })}
              aria-label="Products"
              className="justify-center"
              style={{ marginTop: "20px" }}
            >
              {products.map((product) => (
                <Tab
                  key={product.product_item_id}
                  title={product.product_name || "Unnamed Product"}
                >
                  {/* ***** helmate ****** */}
                  <Helmet>
                    <title>{product.title}</title>
                    <meta
                      name="description"
                      content={product.product_description}
                    />
                    <meta
                      name="keywords"
                      content={product.keyword}
                    />
                    <meta property="og:title" content="Explore Our Product Categories" />
                    <meta property="og:image" content="" />
                    <meta property="og:url" content="https://seaiot.in/products" />
                    <meta property="og:type" content="website" />
                  </Helmet>
                  {/* ***** helmate End ****** */}
                  <div className="product-page">
                    {/* LEFT: images */}
                    <div>
                      <div className="product-media">
                        {/* thumbnails: main + 3D */}
                        <div className="product-thumbs">
                          {product.img_url && (
                            <button
                              type="button"
                              className="product-thumb active"
                            >
                              <img
                                src={`${BASEURL}${product.img_url}`}
                                alt="Main"
                              />
                            </button>
                          )}

                        </div>
                        {/* main zoom wrapper */}
                        <div className="product-image-zoom-wrapper">
                          <div className="product-image-zoom-inner">
                            <img
                              src={`${BASEURL}${product.img_url}`}
                              alt={product.product_name}
                              className="product-image-main"
                            />
                            {/* top‑right badges */}
                            <div className="product-badges">
                              {/* <img src={copper} alt="Copper" className="badge-icon" /> */}
                              <img src={Quality} alt="Quality" className="badge-icon" />
                            </div>
                            <div className="product-image-zoom-lens" />
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="product-actions">
                          {/* <Button color="primary">Add to Cart</Button> */}
                          <Button
                            color="primary"
                            className="ml-2"
                            onPress={() => {
                              if (!product.buynow) return;
                              window.open(product.buynow, "_blank", "noopener,noreferrer");
                            }}
                          >
                            Buy Now
                          </Button>
                          {product.brochure && (
                            <Button
                              // color="b"
                              className="ml-2 brochure"
                              onClick={() => handleOpenBrochure(product)}
                            >
                              <FaFilePdf size={18} color="#ffffff" />
                              Download Brochure
                            </Button>
                          )}
                        </div>
                        <p className="product-short-desc">
                          {product.description || "No description available"}
                        </p>
                      </div>
                    </div>

                    {/* RIGHT: content */}
                    <div className="product-content">
                      <h1 className="product-title">{product.title}</h1>
                      <p className="product-short-desc">
                        {product.product_description || "No description available"}
                      </p>
                      <div className="product-content-button">
                        <Button
                          color="success"
                          className="btn-success"
                          variant="flat"
                          onPress={() => {
                            console.log("WhatsApp clicked");
                            const phone = "918055607812"; // no +, no spaces
                            const messageText = `Hi, I'm interested in the product ${product.title}. Please share the price,and delivery details,
                            ${window.location.href}`;
                            const message = encodeURIComponent(messageText);
                            window.open(`https://wa.me/${phone}?text=${message}`, "_blank");
                          }}
                        >
                          <FaWhatsapp style={{ marginRight: 6 }} />
                          WhatsApp
                        </Button>

                        <Button
                          color="primary" variant="flat"
                          onPress={() => {
                            console.log("Get Best Price clicked");
                            window.location.href = "tel:+918055607812";
                          }}
                        >
                          <FaTag style={{ marginRight: 6 }} />
                          Get Best Price
                        </Button>

                        <Button
                          color="primary" variant="flat"
                          onPress={() => {
                            console.log("Call Now clicked");
                            window.location.href = "tel:+918055607812";
                          }}
                        >
                          <FaPhoneAlt style={{ marginRight: 6 }} />
                          Call Now
                        </Button>
                      </div>
                      <div className="product-div-meta">
                        {product.product_price && (
                          <h4 className="product-price">
                            <span className="price"> ₹ </span>{" "}
                            <span>{product.product_price}</span>
                          </h4>
                        )}
                      </div>
                      <div className="product-specs">
                        {renderParameterTable(product)}
                      </div>
                    </div>
                  </div>
                </Tab>
              ))}
            </Tabs>
          )}
        </div>
      </div>
    </>
  );
}

export default ProductDetails;
